import { COLORS } from 'helpers/globals'

export default {
  markupDetails: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  container: {
    padding: '.8rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'black',
    '& span': {
      width: '5rem'
    }
  },
  goBackButton: {
    marginRight: 7
  },
  targetButton: {
    marginRight: '1rem',
    fontSize: '2rem'
  },
  lockButton: {
    fontSize: '2rem'
  },
  destroyMarkupButton: {
    color: 'red',
    fontSize: '1.9rem',
    float: 'right',
    marginRight: '1rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/MarkupDetails/style.js